import ngStorage from '../../../common/wrappers/ngstorage';
import keepaliveServiceMod from './keepalive.service';

/**
 * Listen to changes in the maintenance status, and store status into the session.
 */
function storeMaintenanceToSession($log, $timeout, $sessionStorage, KeepaliveService) {
  'ngInject';

  KeepaliveService.subscribeMaintenance(status => $timeout(() => {
    $log.debug('Storing maintenance status to session:', status);
    $sessionStorage.keepaliveservice_maintenancestatus = status;
  }));
}
storeMaintenanceToSession.imports = [ngStorage, keepaliveServiceMod];

/**
 * Check if maintenance status exists in session, and store it in the keepalive service if it does. This is to allow
 * rendering contents before the official maintenance status arrives. We trust the status in the session is correct in
 * most of the cases.
 */
function checkMaintenanceSessionStatus($log, $sessionStorage, KeepaliveService) {
  'ngInject';

  if ($sessionStorage.keepaliveservice_maintenancestatus != null) {
    $log.debug(
      'Existing maintenance status found, setting to service:',
      $sessionStorage.keepaliveservice_maintenancestatus
    );
    KeepaliveService._setMaintenanceStatus($sessionStorage.keepaliveservice_maintenancestatus);
  }
}
checkMaintenanceSessionStatus.imports = [ngStorage, keepaliveServiceMod];

export {
  storeMaintenanceToSession,
  checkMaintenanceSessionStatus
};



// WEBPACK FOOTER //
// ./src/app/common/keepalive/maintenance-session.storage.js